export default "__VITE_ASSET__Ca7V0pXj__"